import React from "react";
import api from "../@api";

class controllers extends React.Component {
  getPartnersList = (query) => {
    return new Promise((resolve, reject) => {
      api()
      .get("/partners/find", {params: query})
      .then((response) => {
          if (response.data.status === "success") {
            let data = response.data.result.Partners;
            resolve(data);
          }
          if (response.data.status === "failure") {
            reject("Something is wrong try later or contact the support");
          }
        })
        .catch((err) => {
          reject("Something is wrong try later or contact the support");
        });
    });
  };

}

const instance = new controllers();

export default instance;
